import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Section } from "./Section";
import { Reveal } from "./Reveal";
import { PostCard } from "./PostCard";
import { fetchBlog } from "../../lib/api";

export const BlogSection = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetchBlog()
      .then((r) => setPosts(r.data.slice(0, 3)))
      .catch(() => {});
  }, []);

  if (!posts.length) return null;

  return (
    <Section
      id="blog"
      overline="Journal"
      title="Notes from the estate"
      sub="Market updates, policy explainers and progress from the ground — published regularly by our team."
    >
      <div className="grid gap-5 md:grid-cols-3">
        {posts.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.08}>
            <PostCard post={p} />
          </Reveal>
        ))}
      </div>
      <Reveal delay={0.2}>
        <div className="mt-10 text-center">
          <Link
            to="/blog"
            data-testid="blog-view-all"
            className="inline-block border border-forest px-6 py-3 text-sm font-medium text-forest transition-colors duration-200 hover:bg-forest hover:text-paper"
          >
            View all articles
          </Link>
        </div>
      </Reveal>
    </Section>
  );
};
